import { CartModification } from "@spartacus/cart/base/root";
import { Price } from "@spartacus/core";

export interface GroupCheckoutStep {
    id: string;
    name: string;
    state: GroupCheckoutState;
}

export enum GroupCheckoutState {
    eStateNone = 0,
    eStateGroupDetails = 1 << 0,
    eStatePaymentType = 1 << 1,
    estateAnnualInformation = 1 << 2,
    eStateDeliveryMode = 1 << 3,
    eReviewOrder = 1 << 4,

}

export enum GroupCheckoutUploadState {
    eStateNone = 0,
    eStateAllowUpload = 1 << 0,
    eStateAllowConfirmUpload = 1 << 1,
}

export enum GroupCheckoutButtonState {
    eStateNone = 0,
    eStateConfirmUploadButtonEnabled = 1 << 0,
    eStateUpdateRemarksButtonEnabled = 1 << 1,
}

// export enum GroupCheckoutStepSection {
//     eSectionNone = 0,
//     eSectionGroupInformation = 1 << 0,
//     eSectionAgentInformation = 1 << 1,
//     eSectionBasicInformation = 1 << 2,
//     eSectionParkingReservation = 1 << 3,
//     eSectionRemarks = 1 << 4,
//     eSectionDocumentUpload = 1 << 5,
// }

export interface GroupCheckoutSectionInfo {
    name?: string,
    visible?: boolean,
    expanded?: boolean,
    applicable?: boolean,
    attributes?: GroupCheckoutAttributesInfo[],
}

export interface GroupCheckoutAttributesInfo {
    name?: string,
    visible?: boolean,
    applicable?: boolean,
}

export interface GroupCheckoutStepData {
    cartModifications?: CartModification[],
    groupOrderInfo?: GroupOrderInfo,
    groupRuleData?: GroupRuleData,
    orderCode?: string,
    orderGuid?: string,
    code?: string,
    errors?: GroupCheckoutStepError[],
    preOrder?: boolean,
    placeOrderParams?:GroupCheckoutCVV,
    needVisitorInfo?: boolean,
}
export interface GroupCheckoutCVV{
    securityCode?: string,
}
export interface GroupCheckoutStepError {
    errorCode?: string,
    message?: string,
}

export interface GroupCheckoutType {
    eGroupCheckoutRulesProductType?: GroupCheckoutRulesProductType,
    eGroupCheckoutCustomerBaseType?: GroupCheckoutCustomerBaseType,
}

export enum GroupCheckoutCustomerBaseType {
    // Corresponds to customerBase in GroupRuleData
    eCustomerBaseTypeNone = 0,
    eCustomerBaseTypeDomestic = 1 << 0,
    eCustomerBaseTypeInbound = 1 << 1,
}

export enum GroupCheckoutRulesProductType {
    // Corresponds to rulesProductType in GroupRuleData
    eRulesProductTypeNone = 0,
    eRulesProductTypeGeneral = 1 << 0,
    eRulesProductTypeSchool = 1 << 1,
}

export interface GroupRuleData {
    customerBase?: GroupRulesProductType,
    groupProductType?: string,
    groupTypeId?: string,
    groupTypeName?: string,
    maxQuantity?: number,
    minQuantity?: number,
    productLink?: string,
    ruleOrderType?: string,
    rulesProductType?: GroupRulesProductType,
    sortRank?: number,
    paymentMethods?: GroupRulesKeyValue[],
    deliveryMethods?: GroupRulesKeyValue[],
    needApproval?: boolean,
    /* Ability to select "Digital Delivery" or "Group Sales On-site Pickup" as Delivery Mode
        When selecting "On account" as payment method, the delivery mode of "Digital Delivery" or "Group Sales On-site pickup" are available.
        When selecting "On Site" as payment method, the delivery mode "Group Sales On-site pickup" is available.*/
    eligibleForPreOrder?: boolean,
}

export interface GroupOrderInfo {
    approvalTimeLimit?: number,
    arriveTime?: string,
    busRequired?: boolean,
    draftOrderCreationTime?: string,
    draftOrderModificationTime?: string,
    expectCheckInDate?: string,
    expectCheckOutDate?: string,
    groupAgentInformation?: GroupAgentInformation,
    mainProductCount?: number,
    subTotal?: Price,
    totalTax?: Price,
    totalPriceWithTax?: Price,
    groupInformation?: GroupInformation,
    groupBasicInformation?: GroupBasicInformation,
    groupParkingReservation?: GroupParkingReservationData,
    remarks?: string,
    visitationDate?: string,
    medias?: DocumentDetails[],
    needApprove?: boolean,
    documentsReviewStatus?: string,
    isSavedGroupCart?:boolean,
    orderPlacementStartDate?: string,
    preOrderCutOffDate?: string,
    totalDiscounts?: Price,
}

export interface MediasResponse {
    medias?: DocumentDetails[]
}

export interface DocumentDetails {
    downloadURL?: string,
    realFileName?: string,
    code?: string,
}

export interface GroupParkingReservationData {
    busParkingType?: GroupRulesKeyValue[],
    numberOfVehicles?: number,
    busCompanyName?: string,
    busArrivalPlannedTime?: string,
    busDeparturePlannedTime?: string,
    wheelchairGettingOnAndOff?: GroupRulesKeyValue[],
}

export interface GroupBasicInformation {
    plannedVisitationDate?: string,
    plannedParkEntryTime?: string,
    plannedParkDeparture?: string,
    transportationMethod?: GroupRulesKeyValue[],
    eventNumber?: string,
    purposeOfVisit?: GroupRulesKeyValue[],
}

export interface GroupAgentInformation {
  countryOrPrefecture?: GroupRulesKeyValue[];
  agencyCode?: string;
  agencyName?: string;
  reservationAcceptanceEndDate?: Date;
  organizingBranchName?: string;
  registrationNumber?: string;
  postCode?: string;
  telephoneNumber?: string;
  faxNumber?: string;
  emailAddress?: string;
  confirmationEmailAddress?: string;
  organizingStaffMember?: string;
  organizingTravelAgencyPersonalName?: string;
//   organizingStaffMemberTelephoneNumber?: string; Refactored to organizingTravelAgencyPersonalNumber
    organizingTravelAgencyPersonalNumber?: string;
//   organizingStaffMemberEmailAddress?: string; Refactored to organizingTravelAgencyPersonalEmail
    organizingTravelAgencyPersonalEmail?: string;
    organizingTravelAgencyStaffMember?: string;
    organizingBranchEmailAddress?: string;  // Not used as of now!
}

export interface GroupInformation {
    applicationForReentry?: GroupRulesKeyValue[],
    countryOrPrefecture?: GroupRulesKeyValue[],
    domesticGeneralGroupType?: GroupRulesKeyValue[],
    domesticSchoolGroupType?: GroupRulesKeyValue[],
    inboundGeneralGroupType?: GroupRulesKeyValue[],
    inboundSchoolGroupType?: GroupRulesKeyValue[],
    studioGuide?: GroupRulesKeyValue[],
    groupNameKana?: string,
    groupName?: string,
    postalCode?: string,
    groupAddress?: string,
    schoolName?: string,
    representative?: string,
    responsibleParty1?: string,
    division?: string,
    associatedGroupNames?: string,
    emergencyContactPhoneNumber1?: EmergencyContactPhoneNumberData,
    emergencyContactPhoneNumber2?: EmergencyContactPhoneNumberData,
}

export interface EmergencyContactPhoneNumberData {
    // Raj: The form attributes are flat in UI but only the DTO is hierarchical
    emergencyContactNumber?: string,
    emergencyContactName?: string,
    emergencyContactDivision?: GroupRulesKeyValue[],  // To be changed to GroupRulesKeyValue once backend is updated
}

export interface GroupRulesKeyValue {
    key?: string,
    value?: string,
    selected?: boolean,
    enabled?: boolean,  // For deliveryMethods
}

export interface GroupBasicInformation {

}

export interface KeyValuePair<T = string> {
    key?: T;
    value?: T;
}

export type GroupRulesProductType = KeyValuePair;
export type GroupCustomerBase = KeyValuePair;